(function($) {
  $(function() {
    $('.page-header__menu-toggle').click(function() {
      $('.main-nav').addClass('main-nav--active');
    });

    $('.main-nav__close, .main-nav ul ul a').click(function() {
      $('.main-nav').removeClass('main-nav--active');
    });

    registerBreakpoint(ScreenLG, function() {
      $('.main-nav__item-toggle').remove();
      $('.main-nav').removeClass('main-nav--mobile-init')
      $('.sub-menu').removeAttr('style');
    }, function() {
      if($('.main-nav').hasClass('main-nav--mobile-init')) {
        return;
      }

      var $menuItems = $('.main-nav .menu-item-has-children');
      $menuItems.each(function() {
        var $item = $(this);
        var $toggle = $('<span class="main-nav__item-toggle">')
          .appendTo($item)
          .click(function() {
            console.log($(this));
            $('.main-nav__item-toggle--open').not(this).click();
            var $subMenu = $item.find('.sub-menu');
            $subMenu.stop().slideToggle();
            $toggle.toggleClass('main-nav__item-toggle--open');
          });
      });

      $('.main-nav').addClass('main-nav--mobile-init')
    });
  });
})(jQuery);
